import React from "react";

// Experience Logos
import GD_Script_Logo from "../assets/Gd_script.webp";
import Godot_Logo from "../assets/godot.png";
import Python_Logo from "../assets/python_2023-jan-10_03-29-15pm-000_customizedview21276005086.png";
import Unity_Logo from "../assets/unity-logo-white.png";
import React_Logo from "../assets/React_(web_framework)-Logo.wine.png";
import c_Sharp_Logo from "../assets/63065002cd563e1cd1cead28_eaadfe64.png";

const Experience = () => {
  return (
    <div
      name="experience"
      className="bg-gradient-to-b from-gray-800 to-black w-full min-h-screen text-white py-16"
    >
      <div className="max-w-screen-lg px-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Experience
          </p>
          <p className="py-6">What I have experience in</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
          {/* Experience 1 */}
          <div className="shadow-md shadow-gray-600 rounded-lg">
            <img
              src={GD_Script_Logo}
              alt="GD Script Logo"
              className="rounded-md duration-200 hover:scale-105 w-full h-40 object-contain"
            />
            <div className="flex items-center justify-center p-4">
              <p className="text-lg">GD Script</p>
            </div>
          </div>
          {/* Experience 2 */}
          <div className="shadow-md shadow-gray-600 rounded-lg">
            <img
              src={Godot_Logo}
              alt="Godot Logo"
              className="rounded-md duration-200 hover:scale-105 w-full h-40 object-contain"
            />
            <div className="flex items-center justify-center p-4">
              <p className="text-lg">Godot</p>
            </div>
          </div>
          {/* Experience 3 */}
          <div className="shadow-md shadow-gray-600 rounded-lg">
            <img
              src={Python_Logo}
              alt="Python Logo"
              className="rounded-md duration-200 hover:scale-105 w-full h-40 object-contain"
            />
            <div className="flex items-center justify-center p-4">
              <p className="text-lg">Python</p>
            </div>
          </div>
          {/* Experience 4 */}
          <div className="shadow-md shadow-gray-600 rounded-lg">
            <img
              src={Unity_Logo}
              alt="Unity Logo"
              className="rounded-md duration-200 hover:scale-105 w-full h-40 object-contain"
            />
            <div className="flex items-center justify-center p-4">
              <p className="text-lg">Unity</p>
            </div>
          </div>
          {/* Experience 5 */}
          <div className="shadow-md shadow-gray-600 rounded-lg">
            <img
              src={React_Logo}
              alt="React Logo"
              className="rounded-md duration-200 hover:scale-105 w-full h-40 object-contain"
            />
            <div className="flex items-center justify-center p-4">
              <p className="text-lg">React</p>
            </div>
          </div>
          {/* Experience 6 */}
          <div className="shadow-md shadow-gray-600 rounded-lg">
            <img
              src={c_Sharp_Logo}
              alt="C# Logo"
              className="rounded-md duration-200 hover:scale-105 w-full h-40 object-contain"
            />
            <div className="flex items-center justify-center p-4">
              <p className="text-lg">C#</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
